import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { http } from "../../helpers/http";
import Auth from "../../auth/Auth";
import { useDispatch, useSelector } from "react-redux";
import { getOrdertime } from "../../helpers/help";
import { updateFullScreenLoader } from "../../redux/actions/authActions";
import io from 'socket.io-client';
import { socket } from "../../helpers/socket";
import { socketData } from "../../redux/actions/generalActions";
import moment from "moment";


function OrderStatus() {
  const dispatch = useDispatch();
  const { id: orderId } = useParams();
  const [orderDetails, setOrderDetails] = useState({});
  const navigate = useNavigate();
  const [data, setData] = useState()
  const socketDataOrder = useSelector((state) => state.general.socketData.ordersDetails)
  console.log(socketDataOrder, "socketDataOrder")


  const getOrderStatus = () => {
    // dispatch(updateFullScreenLoader(true));
    http(
      {
        method: "POST",
        url: `trackOrders`,
        isSecure: true,
        body: {
          orderId,
        },
      },
      (res) => {
        if (res.error === "false") {
          setOrderDetails(res.ordersDetails);
          // dispatch(updateFullScreenLoader(false));
        }

      },
      (res) => { }
    );
  };

  useEffect(() => {
    if (!Auth.isUserAuthenticated()) {
      navigate("/");
      return;
    }
    getOrderStatus();
  }, []);



  useEffect(() => {
    // Function to fetch data from the API
    const fetchData = async () => {
      try {
        const jsonData = await getOrderStatus(); // Call the API function
        setData(jsonData);
      } catch (error) {
        // Handle the error
      }
    };
    // Call fetchData initially
    fetchData();
    // Set up an interval to call fetchData every 5 seconds
    const intervalId = setInterval(fetchData, 2000);
    // Clean up the interval when the component unmounts
    return () => clearInterval(intervalId);
  }, []);



  // useEffect(() => {
  //   socket.on('connect', () => {
  //     console.log('Connected to the server');

  //     const sessionStorageData = sessionStorage.getItem("__takk_out");
  //     if (sessionStorageData) {
  //       const id = JSON.parse(sessionStorageData).id;
  //       const userOnlineData = {
  //         id,
  //       };


  //       socket.emit('userOnline', userOnlineData);
  //       console.log(userOnlineData, "userOnlineData", socket, "socket");
  //     } else {
  //       console.error('Error: "__takk_out" not found in sessionStorage or is null.');
  //     }
  //   });
  // }, []);

  // useEffect(() => {

  //   console.log(socket, "socket")
  //   socket.on('orderStatus', data => {
  //     dispatch(socketData(data))
  //     // setOrderDetails(data)
  //     console.log(data, "asdijfoasdjfk");
  //   });
  // }, [socket]);

  // useEffect(() => {
  //   setOrderDetails(socketDataOrder);
  // }, [socketDataOrder])

  // console.log("time", moment(orderDetails.receivedTime).format('YYYY-MM-DD hh:mm:ss'), orderDetails);
  return (
    <>
      <section className="orderStatus">
        <div className="cus_container">
          <div className="arrow_back d-inline" onClick={() => navigate(-1)}>
            <span>
              <img
                src="./assets/img/arrowBack.svg"
                alt="profile"
                className="arrowBack-d"
              />
            </span>
            <span className="ms-2">Back</span>
          </div>
          <h4 className="head4 mb-0 mt-4">Track Order</h4>
          <div className="white_box mt-4 p-sm-4 p-2">

            <div className="row">
              <div className="col-lg-4">
                <h5 className="head5 mb-3">{orderDetails.displayOrderId}</h5>
                <h6 className="head6 mb-1">{orderDetails.outletName}</h6>
                {orderDetails.dishes?.map((item) => (
                  <p key={item.dishplayDish} className="txt mb-1 light_b">
                    {item.dishplayDish}
                  </p>
                ))}
                <p className="txt text-dark">
                  {orderDetails.orderItems}
                  {orderDetails.orderItems > 1 ? " Items" : " Item"}, To pay:{" "}
                  {orderDetails.netAmount ? orderDetails.netAmount.charAt(0) + Number(orderDetails.netAmount.split("$")[1]).toFixed(2) : orderDetails.netAmount}

                </p>

                {
                  orderDetails?.receivedTime ? (
                    <p className="txt">{orderDetails?.restaurantConfirmedDescription}</p>
                  ) :
                    orderDetails?.orderConfirmed ? (
                      <p>{orderDetails?.restaurantConfirmedDescription}</p>

                    ) :
                      orderDetails?.orderReceived ? (
                        <p>{orderDetails?.restaurantConfirmedDescription}</p>
                      ) :
                        orderDetails?.orderPickedUp ? (
                          <p>{orderDetails?.restaurantConfirmedDescription}</p>
                        ) : ""
                }

              </div>




              <div className="col-lg-8 mt-4 mt-lg-0">
                <div className="order_auto">
                  <div className="over_overF">
                    <div className="trckbrd d-flex justify-content-between">
                      <div className="order-tracking">
                        <span className={`mb-2 ${orderDetails.receivedTime ? 'your-class-name' : 'vishidtxt'}`}>
                          {orderDetails.receivedTime ? getOrdertime(orderDetails.receivedTime) : "00:00"}
                        </span>

                        <div
                          className={`circle-tract ${orderDetails.orderReceived === true
                            ? "current-green"
                            : "light_b"
                            }`}

                        >
                          <img src="./assets/img/orderPlaced.svg" alt="orderPlaced" />
                        </div>
                        <p
                          className={`txt mt-2 mb-0 ${orderDetails.orderReceived ? "light_b" : ""
                            }`}
                        >
                          Order Placed
                        </p>
                      </div>
                      <div className="order-tracking">
                        <span className={`mb-2 ${(orderDetails.orderConfirmedTime !== null || orderDetails.rejectedTime !== null) ? 'your-class-name' : 'vishidtxt'}`}>
                          {/* {orderDetails.orderConfirmedTime ? getOrdertime(orderDetails.orderConfirmedTime) : "00:00"} */}

                          {orderDetails.orderConfirmedTime !== null ? getOrdertime(orderDetails.orderConfirmedTime) : getOrdertime(orderDetails.rejectedTime
                          )}
                        </span>
                        <div
                          // className={`circle-tract ${orderDetails.orderConfirmed
                          //   ? orderDetails.orderReceived
                          //     ? orderDetails.readyForPickupTime
                          //       ? "light_b"
                          //       : "current-green"
                          //     : "light_b"
                          //   : "active_tr"
                          //   }`}

                          className={`circle-tract ${(orderDetails.orderReceived === true && (orderDetails.orderConfirmed === true || orderDetails.orderRejected === true)
                          )
                            ? "current-green"
                            : "light_b"
                            }`}

                        >
                          <img src="./assets/img/orderConfirmed.svg" alt="orderConfirmed" />
                        </div>

                        <p
                          className={`txt mt-2 mb-0 ${orderDetails.orderConfirmed ? "light_b" : ""
                            }`}
                        >
                          {orderDetails.status === "rejected" ? "Order Rejected" : "Order Confirmed"}
                        </p>
                      </div>
                      <div className="order-tracking">
                        <span className={`mb-2 ${orderDetails.readyForPickupTime ? 'your-class-name' : 'vishidtxt'}`}>
                          {orderDetails.readyForPickupTime ? getOrdertime(orderDetails.readyForPickupTime) : "00:00"}
                        </span>
                        <div
                          className={`circle-tract ${(orderDetails.readyForPickupTime !== null && orderDetails.orderConfirmed === true)
                            ? "current-green"
                            : "light_b"
                            }`}
                        >
                          <img src="./assets/img/orderPickup.svg" alt="orderPickup" />
                        </div>
                        <p
                          className={`txt mt-2 mb-0 ${orderDetails.readyForPickupTime ? "light_b" : ""
                            }`}
                        >
                          Ready For Pickup
                        </p>
                      </div>
                      <div className="order-tracking">
                        <span className={`mb-2 ${orderDetails.orderPickedupTime ? 'your-class-name' : 'vishidtxt'}`}>
                          {orderDetails.orderPickedupTime ? getOrdertime(orderDetails.orderPickedupTime) : "00:00"}

                        </span>
                        <div
                          className={`circle-tract ${orderDetails.orderPickedUp === true || orderDetails.orderPickedupTime !== null ? "current-green" : "light_b"
                            }`}
                        >
                          <img src="./assets/img/orderPicked.svg" alt="orderPicked" />
                        </div>
                        <p
                          className={`txt mt-2 mb-0 ${orderDetails.orderPickedUp ? "light_b" : ""
                            }`}
                        >
                          Order Picked
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default OrderStatus;
